import { Component, OnInit } from '@angular/core';
import { SegmentRecurringFilters } from '@models/rate-card/segment-recurring-filters';
import { CommonSegmentFilters } from '@models/rate-card/segment-common-filters';
import { AuthService } from '@services/auth/auth.service';
import { LookupV2Service } from '@services/lookup-v2/lookup-v2.service';
import { validateFilters } from '@shared/helpers/functions/filter-helpers';
import { NewDynamicSegments, NewSegmentData, NewSegmentMultiStationData } from '@models/rate-card/rate-card';
import moment from 'moment';
import { NotificationService } from '@services/notification/notification.service';
import { SegmentBaseComponent } from '../segment-base.component';
import { RateCardService } from '@services/rate-card/rate-card.service';
import { Segmentation } from '@models/config';

@Component({
    selector: 'app-recurring-segment',
    templateUrl: './recurring-segment.component.html',
    styleUrls: ['./recurring-segment.component.scss'],
    standalone: false,
})
export class RecurringSegmentComponent extends SegmentBaseComponent implements OnInit {
    recurringFilters!: SegmentRecurringFilters;
    commonSegmentFilters!: CommonSegmentFilters;
    isBulkAddSegment = false;

    constructor(
        protected override authSvc: AuthService,
        protected override lookupSvc: LookupV2Service,
        protected override snackBarSvc: NotificationService,
        protected override rateCardSvc: RateCardService,
    ) {
        super(authSvc, lookupSvc, snackBarSvc, rateCardSvc);
        this.isBulkAddSegment = false;
        // this.isBulkAddSegment = this.config.roleCapability.rate_optics.dynamic_rate_card.bulk_add_segment;
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.recurringFilters = new SegmentRecurringFilters(
            this.lookupSvc,
            this.config,
            this.rowData.rateCardTab,
            this.rowData.channelGroupId,
            this.rowData.channelId,
            this.rowData.spotTypeId,
            this.rowData.daypartId,
            this.rowData.priceFloor,
            this.rowData.priceMax,
            this.rowData.primarySpotLength,
            this.rowData.primaryTier,
            this.segmentData,
        );
        if (this.isBulkAddSegment) {
            this.commonSegmentFilters = new CommonSegmentFilters(
                this.lookupSvc,
                this.config,
                this.rowData.rateCardTab,
                this.rowData.channelGroupId,
                this.rowData.marketId,
                this.rowData.stationId,
                this.segmentData,
            );
        }
    }

    save(): void {
        if (validateFilters([this.recurringFilters]).isValid) {
            if (this.isBulkAddSegment && this.commonSegmentFilters && this.commonSegmentFilters.stations.Value.length > 1) {
                this.saveAndCloseMultiAddSegmentPopup();
                return;
            }
            const dynamicSegments: NewDynamicSegments[] = this.generateDynamicSegmentValues(this.recurringFilters);

            const filterRowData: NewSegmentData = {
                daypartId: this.recurringFilters.dayparts.Value.id,
                rate: this.recurringFilters.rateFilter.Value,
                isOneTimeSegment: false,
                dynamicSegments,
                ...(this.segmentData?.requestId ? { requestId: this.segmentData.requestId } : {}),
            };

            filterRowData.recurringSegment = {
                startDate: moment(this.recurringFilters.startDate.Value).format('YYYY-MM-DD'),
                endDate: moment(this.recurringFilters.endDate.Value).format('YYYY-MM-DD'),
                dows: this.recurringFilters.dow.Value.ids,
                hiatusWeeks: this.recurringFilters.hiatusWeeks.Value,
            };
            this.saveAndCloseAddSegmentPopup([filterRowData]);
        } else {
            this.snackBarSvc.openSnackBar('At least one filter is invalid', 'error');
        }
    }

    saveAndCloseMultiAddSegmentPopup() {
        const dynamicSegments: NewDynamicSegments[] = this.generateDynamicSegmentValues(this.recurringFilters);

        const channelSelected =
            this.commonSegmentFilters.channels.Value.length > 0
                ? this.commonSegmentFilters.channels.Value.map((channel) => channel.id)
                : [this.rowData.channelId];

        const parentSegmentData = {
            daypartId: this.segmentData ? this.segmentData.parentSegmentData.daypartId : this.rowData.daypartId,
            dynamicSegmentation: this.segmentData
                ? this.segmentData.parentSegmentData.dynamicSegmentation
                : this.rowData.parentDynamicSegmentation,
        };

        const filterRowData: NewSegmentMultiStationData = {
            daypartId: this.recurringFilters.dayparts.Value.id,
            isOneTimeSegment: false,
            dynamicSegments,
            ...(this.segmentData?.requestId ? { requestId: this.segmentData.requestId } : {}),
            startDate: moment(this.recurringFilters.startDate.Value).format('YYYY-MM-DD'),
            endDate: moment(this.recurringFilters.endDate.Value).format('YYYY-MM-DD'),
            hiatusWeeks: this.recurringFilters.hiatusWeeks.Value,
            dows: this.recurringFilters.dow.Value?.ids || [],
            channels: channelSelected,
            rateCardTab: this.rowData.rateCardTab,
            isDynamic: this.rowData.isDynamic,
            isPolitical: this.rowData.isPolitical,
            spotTypeId: this.rowData.spotTypeId,
            rate: this.recurringFilters.rateFilter.Value,
            reloadParams: this.rowData.reloadParams,
            parentSegmentData,
        };
        this.commonSaveFunc([filterRowData]);
    }

    generateNewDowDynamicSegment(segment: Segmentation, filter: SegmentRecurringFilters) {
        return {
            segmentType: segment.segment_type,
            segmentValue: filter.dow.Value.name,
        };
    }
}
